import { render, staticRenderFns } from "./iri-info.vue?vue&type=template&id=780fa9fc&"
import script from "./iri-info.vue?vue&type=script&lang=ts&"
export * from "./iri-info.vue?vue&type=script&lang=ts&"
import style0 from "./iri-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports